import Component from '../core/Component'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class PlanFloors extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            list: null,
            toggle: null,
            label: null,
            value: null
        }

        this.isActive = false
    }

    prepare() {
        this.ref.toggle.addEventListener('click', this.handleToggleClick)
        EventBus.on('plan:floor:change', this.handleFloorChange)

        const plan = Component.getFromElement(this.element.closest('[data-component="Plan"]'))

        const floor = plan.getCurrentFloor()

        this.update(floor?.label)
    }

    destroy() {
        EventBus.off('plan:floor:change', this.handleFloorChange)
        document.removeEventListener('click', this.handleOuterClick)
    }

    handleFloorChange = ({ id, label }) => {
        this.update(label)
        this.close()
    }

    handleToggleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    handleOuterClick = event => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    update(label = '') {
        this.ref.value.textContent = label
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)
        this.ref.list.style.height = `${this.ref.list.scrollHeight}px`
        document.addEventListener('click', this.handleOuterClick)
    }

    close() {
        this.ref.list.style.height = '0px'
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('click', this.handleOuterClick)
    }
}
